import { Box } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

export default function MultiLineChart() {
	const state = useSelector((store) => store.analyze);
	const { customerMLCDPrepared, selectedScenarioName, duration, customerChecked } = state;
	const { periods, seriesData } = customerMLCDPrepared;

	const options = {
		title: {
			text: `Analyze: ${selectedScenarioName} Last ${duration} Months`,
			align: "left",
		},
		tooltip: {
			y: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		xaxis: {
			categories: [...periods],
		},
		yaxis: {
			labels: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		stroke: {
			width: 3,
		},
		markers: {
			size: 5,
		},
		colors: ["#00BFFF", "orange", "#FFD700" ],
	};
	//const series = [...seriesData];
	const series = seriesData?.filter((item) => {
		return customerChecked.includes(item.name);
	})

	console.log(seriesData);
	console.log(customerChecked)

	return (
		// added class name to get this element.
		<Box sx={{ mt: 2 }} className={"multiLineChart"}>
			<Chart
				options={options}
				series={series}
				type="line"
				height={500}
				width={"99%"}
			/>
		</Box>
	);
}
